document.addEventListener('DOMContentLoaded', () => {
  const contactRoot = document.querySelector('.js-contact-form');
  const form = contactRoot ? contactRoot.closest('form') : null;
  const inputSection = document.querySelector('.js-contact-input');
  const confirmSection = document.querySelector('.js-contact-section');

  if (!contactRoot || !form || !inputSection || !confirmSection) return;

  const confirmBtn = inputSection.querySelector('.js-contact-confirm');
  const backBtn = confirmSection.querySelector('.js-contact-back');
  const contactSubmitBtn = confirmSection.querySelector('.js-contact-submit');
  const cf7SubmitBtn = contactRoot.querySelector('.js-cf7-submit');
  const privacyCheckbox = contactRoot.querySelector('.contact__form-checkbox');
  const privacyAgree = contactRoot.querySelector('.contact__form-privacy-agree');

  if (!confirmBtn) return;

  confirmSection.classList.add('is-hidden');

  // フォーム内でEnterキーによる暗黙の送信を禁止する（textareaの改行・ボタンのEnter操作は維持する）
  form.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;

    const {tagName} = event.target;
    if (tagName === 'TEXTAREA' || tagName === 'BUTTON') return;

    event.preventDefault();
  });

  const confirmMap = {
    contact_type: 'type',
    your_name: 'name',
    your_kana: 'kana',
    your_tel: 'tel',
    your_email: 'email',
    cat_count: 'cat-count',
    age_group: 'age-group',
    your_message: 'message',
  };

  const requiredFieldNames = ['contact_type', 'your_name', 'your_kana', 'your_tel', 'your_email', 'your_message'];

  const requiredMessages = {
    contact_type: 'お問い合わせ種別を選択してください。',
    your_name: 'お名前を入力してください。',
    your_kana: 'ふりがなを入力してください。',
    your_tel: '電話番号を入力してください。',
    your_email: 'メールアドレスを入力してください。',
    your_message: 'お問い合わせ内容を入力してください。',
  };

  const scrollToPageTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const resetPrivacyError = () => {
    if (privacyAgree) {
      privacyAgree.classList.remove('is-error');
      const error = privacyAgree.querySelector('.js-contact-error');
      if (error) error.remove();
    }
  };

  const isFieldEmpty = (field) => field.value.trim() === '';

  const getValidationMessage = (field) => {
    if (requiredFieldNames.includes(field.name) && isFieldEmpty(field)) {
      return requiredMessages[field.name];
    }

    if (field.name === 'your_kana' && !/^[ぁ-ゖゝゞー\s]+$/.test(field.value)) {
      return 'ひらがなで入力してください。';
    }

    if (field.name === 'your_tel' && !/^\d{10,11}$/.test(field.value)) {
      return '電話番号は、ハイフンなしの半角数字10〜11桁で入力してください。';
    }

    if (field.name === 'your_email' && field.validity.typeMismatch) {
      return '正しい形式のメールアドレスを入力してください。';
    }

    if (field.validity.tooLong) {
      return `${field.maxLength}文字以内で入力してください。`;
    }

    return '';
  };

  const getErrorContainer = (field) => {
    return field.closest('.wpcf7-form-control-wrap') || field.parentElement;
  };

  const showFieldError = (field, message) => {
    const container = getErrorContainer(field);
    let error = container.querySelector('.js-contact-error');

    container.querySelectorAll('.wpcf7-not-valid-tip').forEach((tip) => tip.remove());

    field.classList.toggle('-error', Boolean(message));
    field.setAttribute('aria-invalid', message ? 'true' : 'false');
    field.setCustomValidity(message);

    if (!message) {
      if (error) error.remove();
      return;
    }

    if (!error) {
      error = document.createElement('span');
      error.className = 'contact__form-error js-contact-error';
      error.setAttribute('role', 'alert');
      container.appendChild(error);
    }

    error.textContent = message;
  };

  const validateField = (field) => {
    field.setCustomValidity('');
    const message = getValidationMessage(field);
    showFieldError(field, message);
    return !message;
  };

  const scrollToInvalidField = (field) => {
    const target = field.closest('.contact__form-item') || field;
    target.scrollIntoView({behavior: 'smooth', block: 'center'});
    field.focus({preventScroll: true});
  };

  const getFieldValue = (field) => {
    if (!field) return '';

    if (field.tagName === 'SELECT') {
      const selectedOption = field.options[field.selectedIndex];

      if (!selectedOption || !field.value) {
        return '';
      }

      return selectedOption.textContent.trim();
    }

    if (field.type === 'checkbox') {
      return field.checked ? field.value : '';
    }

    return field.value.trim();
  };

  const nl2br = (text) => {
    const fragment = document.createDocumentFragment();
    const lines = text.split(/\r\n|\n|\r/);

    lines.forEach((line, index) => {
      if (index > 0) {
        fragment.appendChild(document.createElement('br'));
      }

      fragment.appendChild(document.createTextNode(line));
    });

    return fragment;
  };

  const getRequiredFields = () => {
    return requiredFieldNames.map((fieldName) => contactRoot.querySelector(`[name="${fieldName}"]`)).filter(Boolean);
  };

  const isInputComplete = () => {
    const requiredFields = getRequiredFields();

    const isFieldsComplete = requiredFields.every((field) => {
      if (field.tagName === 'SELECT') {
        return field.value !== '';
      }

      if (field.type === 'checkbox') {
        return field.checked;
      }

      return field.value.trim() !== '';
    });

    const isPrivacyChecked = privacyCheckbox ? privacyCheckbox.checked : true;

    return isFieldsComplete && isPrivacyChecked;
  };

  const updateConfirmButtonState = () => {
    if (isInputComplete()) {
      confirmBtn.classList.remove('-disabled');
    } else {
      confirmBtn.classList.add('-disabled');
    }
  };

  const setConfirmValues = () => {
    Object.keys(confirmMap).forEach((fieldName) => {
      const field = contactRoot.querySelector(`[name="${fieldName}"]`);
      const key = confirmMap[fieldName];
      const target = confirmSection.querySelector(`[data-confirm-target="${key}"]`);

      if (!field || !target) return;

      const value = getFieldValue(field);

      target.textContent = '';

      if (field.tagName === 'TEXTAREA') {
        target.appendChild(nl2br(value));
      } else {
        target.textContent = value;
      }
    });
  };

  const contactFields = Array.from(contactRoot.querySelectorAll('.js-contact-field'));

  contactFields.forEach((field) => {
    field.addEventListener('blur', () => validateField(field));
    field.addEventListener('change', () => {
      validateField(field);
      updateConfirmButtonState();
    });
    field.addEventListener('input', () => {
      if (field.classList.contains('-error')) validateField(field);
      updateConfirmButtonState();
    });
  });

  if (privacyCheckbox) {
    privacyCheckbox.addEventListener('change', () => {
      resetPrivacyError();
      updateConfirmButtonState();
    });
  }

  updateConfirmButtonState();

  confirmBtn.addEventListener('click', () => {
    resetPrivacyError();

    const validationResults = contactFields.map((field) => ({
      field,
      isValid: validateField(field),
    }));
    const firstInvalidResult = validationResults.find((result) => !result.isValid);
    const firstInvalidField = firstInvalidResult ? firstInvalidResult.field : null;

    if (firstInvalidField) {
      scrollToInvalidField(firstInvalidField);
      updateConfirmButtonState();
      return;
    }

    if (privacyCheckbox && !privacyCheckbox.checked) {
      if (privacyAgree) {
        privacyAgree.classList.add('is-error');
        const error = document.createElement('span');
        error.className = 'contact__form-error js-contact-error';
        error.setAttribute('role', 'alert');
        error.textContent = '個人情報についての同意が必要です。';
        privacyAgree.appendChild(error);
      }

      scrollToInvalidField(privacyCheckbox);
      updateConfirmButtonState();
      return;
    }

    setConfirmValues();

    inputSection.classList.add('is-hidden');
    confirmSection.classList.remove('is-hidden');

    scrollToPageTop();
  });

  if (backBtn) {
    backBtn.addEventListener('click', () => {
      confirmSection.classList.add('is-hidden');
      inputSection.classList.remove('is-hidden');

      scrollToPageTop();
    });
  }

  if (contactSubmitBtn && cf7SubmitBtn) {
    contactSubmitBtn.addEventListener('click', () => {
      cf7SubmitBtn.click();
    });
  }

  document.addEventListener('wpcf7mailsent', () => {
    window.location.href = '/contact/thanks/';
  });
});
